import {
    /** FETCH APPLICATION  */
    FETCH_CONCLUDEAPPLICATION_FULFILLED,
    FETCH_CONCLUDEAPPLICATION_REJECTED,
    FETCH_CONCLUDEAPPLICATION_PENDING,
    RESET_CONCLUDEAPPLICATION
} from "../../actions/v3/concludeApplication";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CONCLUDEAPPLICATION_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_CONCLUDEAPPLICATION_FULFILLED:
            return {
                ...state,
                concludeApplication: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_CONCLUDEAPPLICATION_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_CONCLUDEAPPLICATION:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};